import { Injectable } from '@angular/core';
import { WmHttpService } from "@wms/services";
import { environment } from "@wms/app";

@Injectable({
  providedIn: 'root'
})
export class DeploymentProfilesService {
  TARGET = "DeploymentProfiles";
  API_META = {
    list: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/profiles/profile-names",
      method: 'GET',
      embedModeAPI: true,
      spinnerInfo: {
        showSpinner: false
      }
    },
    createProfile: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/profiles",
      method: 'POST'
    },
    getProfile: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/profiles/:profileName",
      method: 'GET'
    },
    updateProfile: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/profiles/:profileName",
      method: 'PUT'
    },
    deleteProfile: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/profiles/:profileName",
      method: 'DELETE'
    },
    appEnvironmentProfile: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/properties",
      method: 'PUT'
    },
    appEnvironmentProperties: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/properties/keys",
      method: 'GET'
    },
    getContainerServicesDeployedUrl: {
      url: "/deployment-cloud/rest/projects/:projectID/deployment-url",
      method: 'GET'
    },
    getKubernetesDeployedUrl: {
      url: "/deployment-bridge/rest/project/deployment-target/deployment-url?projectId=:projectID",
      method: 'GET'
    }
  }
  constructor(private wmHttpService: WmHttpService) {
    wmHttpService.registerApiMeta(this.TARGET, this.API_META);
  }

  // get the list of all the deployment profiles
  list(projectId: any): Promise<any> {
    return (this.wmHttpService.execute({
      target: "DeploymentProfiles",
      action: "list",
      urlParams: {
        projectID: projectId
      }
    }) as Promise<any>)
  }
}
